/* eslint-disable
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {noop} from '@benchling/js-utils';
import Backbone from 'backbone';
import DOMPurify from 'dompurify';
import $ from 'jquery';
import {marked} from 'marked';
import _ from 'underscore';

import setTestAttrs from 'test/lib/cypress/setTestAttrs';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import Popup2Template, {Popup2Props} from 'util/Popup2Template';
import PopupTemplate, {PopupProps} from 'util/PopupTemplate';

interface ConfirmInitializationOptions<TModel extends Backbone.Model> extends Backbone.ViewOptions<TModel> {
  classes?: string;
  closeable?: boolean;
  hideOnSubmit?: boolean;
  msg: string | JQuery;
  noPadding?: boolean;
  title: string;
  view?: Backbone.View<TModel>;
}

type ConfirmModalChoice = [string, string, () => void, boolean, string, DataTestAttrs?];

class Confirm<TModel extends Backbone.Model = Backbone.Model> extends Backbone.View<TModel> {
  body!: string | JQuery;
  cancelHandler!: () => void;
  choices!: Array<ConfirmModalChoice>;
  classes?: string;
  closeable?: boolean;
  hideOnSubmit?: boolean;
  noPadding?: boolean;
  template!: (props: PopupProps) => string;
  title!: string;
  view?: Backbone.View<TModel>;

  constructor(options: ConfirmInitializationOptions<TModel>) {
    super(options);
  }

  static initClass(): void {
    this.prototype.tagName = 'div';
    this.prototype.className = 'modal js-popup-modal';
    this.prototype.attributes = {tabindex: -1};
    this.prototype.template = PopupTemplate;
  }

  override events(): Backbone.EventsHash {
    return {
      keydown: 'handleKey',
    };
  }

  handleKey(e: JQueryEventObject): JQuery | void {
    if (this.hideOnSubmit && e.which === 13) {
      const $btn = this.$el.find('.modal-footer').find('.btn-af-primary, .btn-af-success');
      if ($btn.length === 1) {
        e.stopPropagation();
        return $btn.click();
      }
    }
  }

  override initialize(options: ConfirmInitializationOptions<TModel>): void {
    let msg, title;
    this.choices = [];
    this.cancelHandler = function () {};
    ({msg, title, classes: this.classes, view: this.view} = options);
    this.body = msg;
    this.title = DOMPurify.sanitize(marked(title));
    _.defaults(options, {hideOnSubmit: true, closeable: true});
    ({hideOnSubmit: this.hideOnSubmit, closeable: this.closeable, noPadding: this.noPadding} = options);

    this.$el.on('hidden.bs.modal', () => (this.view != null ? this.view.remove() : undefined));
  }

  cancel(f: () => void): this {
    this.cancelHandler = f;
    return this;
  }

  linkChoice(labelName: string, className: string, handler: () => void, autoClose: boolean = true): this {
    this.choices.push([labelName, className, handler, autoClose, 'a']);
    return this;
  }

  choice(
    labelName: string,
    className: string,
    handler: () => void = noop,
    autoClose: boolean = true,
    dataTestAttrs: DataTestAttrs = {}
  ): this {
    this.choices.push([labelName, className, handler, autoClose, 'button', dataTestAttrs]);
    return this;
  }

  show(): void {
    let modalOptions;
    this.render();
    // This assumes we never open a Backbone modal from a React modal. We always insert before the
    // modal-container so that, if the Backbone modal does open a React modal, the React modal appears
    // over the existing modals.
    $('.modal-container').before(this.$el);
    if (this.closeable) {
      modalOptions = {};
    } else {
      modalOptions = {
        backdrop: 'static',
        keyboard: false,
      };
    }
    this.$el.modal(modalOptions);
    this.$el.modal('show');
  }

  close(): void {
    this.$el.modal('hide');
  }

  callHandler(handler: () => void): void {
    handler.call(this);
  }

  override render(): this {
    this.$el.html(this.template({title: this.title, closeable: this.closeable ?? false}));
    // @ts-expect-error JQuery silently accepts nullish values in `addClass` and then short-circuits
    this.$el.find('.modal-dialog').addClass(this.classes);
    // @ts-expect-error JQuery accepts (and sanitizes) pretty much whatever in `html` but we really shouldn't
    // do this
    this.$el.find('.modal-body').html(this.body);
    if (this.noPadding) {
      this.$el.find('.modal-body').css('padding-top', 0);
    }

    const footer = this.$el.find('.modal-footer');
    for (const choice of Array.from(this.choices)) {
      // eslint-disable-next-line no-restricted-syntax, @typescript-eslint/unbound-method
      const callHandler: (fn: () => void) => this = _.bind(this.callHandler, this);
      (function (
        [labelName, className, handler, autoClose, tagName, dataTestAttrs]: ConfirmModalChoice,
        $el: JQuery
      ) {
        tagName = tagName || 'button';
        const btn = $(`<${tagName}>${labelName}</${tagName}>`)
          .attr({type: 'button', 'data-loading-text': 'Working...'})
          .addClass('btn')
          .addClass(className)
          .click(() => {
            if (handler != null) {
              callHandler(handler);
            }
          });
        setTestAttrs(btn, dataTestAttrs);
        if (autoClose) {
          if (tagName === 'a') {
            btn.click(() => $el.modal('hide'));
          } else {
            btn.attr('data-dismiss', 'modal');
          }
        } else {
          btn.click(function () {
            // @ts-expect-error We are not defining the type of `this`
            return $(this).button('loading');
          });
        }

        return footer.append(btn);
      })(choice, this.$el);
    }

    // eslint-disable-next-line no-restricted-syntax, @typescript-eslint/unbound-method
    this.$el.on('hidden.bs.modal', _.bind(this.remove, this));
    setTestAttrs(this.$el, this.getDataTestAttrs());
    return this;
  }

  /**
   * Can be overridden to specify an object of test attributes to expose.
   */
  getDataTestAttrs(): DataTestAttrs | null {
    return null;
  }
}

Confirm.initClass();

type ButtonStyle = 'red' | 'blue' | 'green' | 'grey' | null;

interface ButtonInitializationOptions<TModel extends Backbone.Model> extends Backbone.ViewOptions<TModel> {
  type?: string;
  text?: string;
  style?: ButtonStyle;
  dataTestAttrs?: DataTestAttrs;
  action?: () => void;
}

class Button<TModel extends Backbone.Model> extends Backbone.View<TModel> {
  action!: (() => void) | null;
  dataTestAttrs?: DataTestAttrs;
  style!: ButtonStyle;
  text!: string;
  type!: string;

  static initClass(): void {
    this.prototype.tagName = 'button';
  }

  override initialize(options: ButtonInitializationOptions<TModel>): void {
    this.type = options.type || 'button';
    this.text = options.text || '';
    this.style = options.style || null;
    this.dataTestAttrs = options.dataTestAttrs;
    this.action = options.action || (this.type === 'cancel' ? noop : null);
  }

  enabled(enabled: boolean): void {
    this.$el.toggleClass('disabled', !enabled);
    // @ts-expect-error DefinitelyTyped is wrong, we actually can pass boolean to `JQuery.attr`
    this.$el.attr('disabled', !enabled);
  }

  override render(): this {
    const btnClass = (() => {
      switch (this.style) {
        case 'red':
          return 'btn-af-danger';
        case 'blue':
          return 'btn-af-primary';
        case 'green':
          return 'btn-af-success';
        case 'grey':
          return 'btn-af-default';
        default:
          switch (this.type) {
            case 'submit':
              return 'btn-af-success';
            case 'cancel':
              return 'btn-af-default';
            default:
              return 'btn-af-default';
          }
      }
    })();
    this.$el
      .text(_.result(this, 'text'))
      .attr({
        type: this.type === 'submit' ? 'submit' : 'button',
        'data-loading-text': 'Working...',
      })
      .addClass('btn')
      .addClass(btnClass)
      .addClass(`js-popup-${this.type}`)
      .click(() => {
        this.$el.button('loading');
        if (typeof this.action === 'function') {
          this.action();
        }
      });
    setTestAttrs(this.$el, this.dataTestAttrs);
    return this;
  }
}

Button.initClass();

const POPUP_CLASSNAME = 'modal js-popup-modal';

class Popup<TModel extends Backbone.Model> extends Backbone.View<TModel> {
  $body?: JQuery;
  buttons!: Array<Button<TModel>>;
  static className: typeof POPUP_CLASSNAME;
  $footer!: JQuery;
  modalOptions?: never;
  _template!: (props: Popup2Props) => string;

  static initClass(): void {
    this.prototype.tagName = 'div';
    this.prototype.className = POPUP_CLASSNAME;
    this.className = POPUP_CLASSNAME;
    this.prototype.attributes = {tabindex: -1};
    this.prototype._template = Popup2Template;
  }

  choice(options: ButtonInitializationOptions<TModel>): this {
    const button = new Button(options);
    this.$footer.append(button.render().el);
    this.buttons.push(button);
    return this;
  }

  close(): JQuery {
    return this.$el.modal('hide');
  }

  form(): void {}

  doSubmit(e: JQueryEventObject): JQuery | void {
    e.preventDefault();
    if (this.validate()) {
      return this.submit();
    }
  }

  submit(): JQuery {
    return this.close();
  }

  cancel(): JQuery {
    return this.close();
  }

  validate(): boolean {
    return true;
  }

  focus(): void {}

  check(): void {
    const v = this.validate();
    for (const button of this.buttons) {
      if (button.type !== 'cancel') {
        button.enabled(v);
      }
    }
  }

  show(): void {
    this.render();
    // This assumes we never open a Backbone modal from a React modal. We always insert before the
    // modal-container so that, if the Backbone modal does open a React modal, the React modal appears
    // over the existing modals.
    $('.modal-container').before(this.$el);
    this.$el.modal(this.modalOptions);
    this.$el.modal('show');
    this.check();
    this.focus();
  }

  renderTemplate(): string {
    return this._template({title: _.result(this, 'title')});
  }

  override render(): this {
    const $template = $(this.renderTemplate());
    this.$footer = $template.find('.modal-footer');
    this.$body = $template.find('.modal-body');
    this.buttons = [];

    this.form();

    // @ts-expect-error You can, but should not, pass JQuery objects to `JQuery.html`
    this.$el.html($template);
    this.$el.on('hidden.bs.modal', () => this.remove());

    setTestAttrs(this.$el, this.getDataTestAttrs());

    // Have submit submit.
    const defaults = {
      'submit form.popup-form': 'doSubmit',
      'click .js-popup-cancel': 'cancel',
    };

    const events = _.defaults(_.result(this, 'events') || {}, defaults);
    this.delegateEvents(events);
    return this;
  }

  /**
   * Can be overridden to specify an object of test attributes to expose.
   */
  getDataTestAttrs(): DataTestAttrs | null {
    return null;
  }
}

Popup.initClass();

export {Confirm, Popup};
